import script from "./nav-back-top.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-back-top.vue?vue&type=script&setup=true&lang=js"

import "./nav-back-top.vue?vue&type=style&index=0&id=306c67a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306c67a8"]])

export default __exports__